import { Component, OnInit } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';

import { TabBarLinkInterface } from '~/component/router-tab-bar/interfaces/tab-link.interface';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

import { getRouteTabBarActivities } from '~/organizer/shared/helpers/activity/list/activity-list-tab-bar.helper';

@Component({
  selector: 'app-organizer-timeslot-schedule',
  templateUrl: './schedule.component.html',
})
export class OrganizerTimeslotPageScheduleComponent implements OnInit {
  public readonly iconTypeEnum = VtmnPlayIconTypeEnum;
  public tabBarlinks: TabBarLinkInterface[] = [];

  constructor(
    private readonly translateService: TranslateService,
    private readonly localizeRouterService: LocalizeRouterService
  ) {}

  public ngOnInit(): void {
    const tabBarActivities = getRouteTabBarActivities(
      'activity',
      this.translateService,
      this.localizeRouterService
    );

    this.tabBarlinks = this.tabBarlinks?.concat(tabBarActivities);
  }
}
